import React from "react";
import { useTranslation } from "react-i18next";
import LifestyleUseCases from "../LifestyleUseCases";
import { useRingLifestyleData } from "./ringData";

const LifestyleUseCasesRing: React.FC = () => {
    const { t } = useTranslation("ringLifestyle");
    const ringLifestyleData = useRingLifestyleData();

    return (
        <LifestyleUseCases
            data={ringLifestyleData}
            sectionTitle={{
                regularText: t("sectionTitle.regularText"),
                highlightedText: t("sectionTitle.highlightedText"),
                descriptionHighlight: t("sectionTitle.descriptionHighlight"),
                descriptionText: t("sectionTitle.descriptionText"),
            }}
            className="ring-lifestyle-section"
        />
    );
};

export default LifestyleUseCasesRing;
